module.exports = __webpack_public_path__ + "static/dresswing-export-38b7d632deca86b364b1cc19d2b74a0e.mp4";